import React from 'react'
import styled, { css, keyframes } from 'styled-components'

const translate = keyframes`
  0% {
    transform: translateY(12px);
  }
  50% {
    transform: translateY(-6px);
  }
  100% {
    transform: translateY(-6px);
  }
`

const animation = css`
  ${translate} 1s cubic-bezier(0.76, 0, 0.24, 1) infinite;
`

const Mask = styled('mask')({
  'mask-type': 'alpha',
  '> rect': {
    animation: animation
  }
})

export const Loading = ({
  width = 64,
  height = 64,
  color = '#FFF',
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="64" height="64" rx="10" fill="black" fillOpacity="0.2" />
      <Mask
        id="mask0_501_14"
        maskUnits="userSpaceOnUse"
        x="32"
        y="-12"
        width="64"
        height="88"
      >
        <rect x="32" y="-12" width="64" height="16" rx="2" fill={color} />
        <rect x="32" y="6" width="64" height="16" rx="2" fill={color} />
        <rect x="32" y="24" width="64" height="16" rx="2" fill={color} />
        <rect x="32" y="42" width="64" height="16" rx="2" fill={color} />
        <rect x="32" y="60" width="64" height="16" rx="2" fill={color} />
      </Mask>
      <g mask="url(#mask0_501_14)">
        <rect width="64" height="64" rx="10" fill="white" />
      </g>
    </svg>
  )
}
